import React, { useContext, useEffect, useRef, useState } from "react";
import supabase from "../supabase/supabaseClient";
import { DataContext } from "../context/DataContext";
import estilo from "./styles/Chat.module.css";
import { tiempoTranscurrido } from "../utils/TiempoHoras";
import { usePageVisibility } from "react-page-visibility";
import { useNavigate } from "react-router-dom";

function Chat({ receptor }) {
  let navigate = useNavigate();

  const scrollRef = useRef(null);
  const mensajeAreaRef = useRef(null);

  const { usuario, url } = useContext(DataContext);

  const [mensaje, setMensaje] = useState("");
  const [mensajes, setMensajes] = useState([]);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const [receptorDatos, setReceptorDatos] = useState([]);

  //controlador
  const isVisible = usePageVisibility();

  React.useEffect(() => {
    if (isVisible) {
      actualizarEstado(true);
    } else {
      actualizarEstado(false);
    }
  }, [isVisible]);

  async function actualizarEstado(conectado) {
    await supabase
      .from("usuarios_chat")
      .update({ estado: conectado })
      .eq("user_id", usuario.id);
  }

  // async function mensajeVisto() {
  //   let arregloActualizado = [];

  //   if (receptorDatos.length > 0) {
  //     arregloActualizado = visto.map((e) => {
  //       if (e.nombre_usuario == receptorDatos[0].nombre_usuario) {
  //         return { ...e, visto: true };
  //       } else {
  //         return e;
  //       }
  //     });
  //   }

  //   if (arregloActualizado.length > 0) {
  //     arregloActualizado.forEach(async (mensaje) => {
  //       const { data, error } = await supabase
  //         .from("mensajes_chat")
  //         .upsert(mensaje, { onConflict: ["id"] });
  //       if (data) {
  //         console.log(data);
  //       }
  //     });
  //   }
  // }

  //traer mensajes filtrando solo coincidencias con user_id y user_id_chat
  useEffect(() => {
    const fetchMensajes = async () => {
      const { data, error } = await supabase.from("mensajes_chat").select();

      if (data) {
        setMensajes(
          data
            .sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
            .filter(
              (e) =>
                (e.user_id === usuario.id && e.user_id_chat === receptor) ||
                (e.user_id === receptor && e.user_id_chat === usuario.id)
            )
        );
      }
      ajustarAlturaTextarea();
    };

    fetchMensajes();
  }, []);

  //traer datos del receptor
  useEffect(() => {
    const fetchReceptor = async () => {
      const { data, error } = await supabase
        .from("usuarios_chat")
        .select()
        .eq("user_id", receptor);

      if (data) {
        setReceptorDatos(data);
      }
      if (error) {
        navigate("/");
      }
    };

    fetchReceptor();
  }, [isVisible, mensajes]);

  //escuchar cambios
  // useEffect(() => {
  //   const realTime = async () => {
  //     const { data, error } = await supabase
  //       .channel("mensajes_chat")
  //       .on(
  //         "postgres_changes",
  //         {
  //           event: "INSERT",
  //           schema: "public",
  //         },
  //         (payload) => console.log(payload.new)
  //       )
  //       .subscribe();
  //   };

  //   realTime();
  // }, []);

  //escuchar cambio de una tabla
  useEffect(() => {
    const realTime = async () => {
      supabase
        .channel("any")
        .on(
          "postgres_changes",
          { event: "INSERT", schema: "public", table: "mensajes_chat" },
          (payload) => {
            setMensajes((prevMessages) => {
              const newMessages = Array.isArray(payload.new)
                ? payload.new
                : [payload.new];

              return prevMessages.concat(
                newMessages.filter(
                  (e) =>
                    (e.user_id === usuario.id && e.user_id_chat === receptor) ||
                    (e.user_id === receptor && e.user_id_chat === usuario.id)
                )
              );
            });
            abajo();
            console.log(payload.errors);
          }
        )
        .subscribe();
    };

    realTime();
  }, []);

  //scroll y mensajes abajo
  useEffect(() => {
    const container = scrollRef.current;

    const handleScroll = () => {
      const isAtBottom =
        container.scrollHeight - container.scrollTop === container.clientHeight;

      if (isAtBottom) {
        setShouldAutoScroll(true);
      } else {
        setShouldAutoScroll(false);
      }
    };

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const container = scrollRef.current;

    if (shouldAutoScroll) {
      container.scrollTop = container.scrollHeight;
    }
  }, [mensajes, mensaje, shouldAutoScroll]);

  function abajo() {
    const container = scrollRef.current;
    container.scrollTop = container.scrollHeight;
    window.scrollTo(0, document.body.scrollHeight);
  }

  //ajuste de altura del textarea
  const ajustarAlturaTextarea = () => {
    const textarea = mensajeAreaRef.current;
    const maxAlturaTextarea = 80;

    if (textarea) {
      textarea.style.height = "40px";
      textarea.style.height = `${textarea.scrollHeight}px`;

      if (textarea.scrollHeight > maxAlturaTextarea) {
        textarea.style.height = `${maxAlturaTextarea}px`;
        textarea.style.overflowY = "40px";
      } else {
        textarea.style.overflowY = "hidden";
      }
    }
  };

  //capturar input
  function capturarTexto(e) {
    setMensaje(e.target.value);
    ajustarAlturaTextarea();
    abajo();
  }

  //enviar mensaje
  async function enviarMensaje(e) {
    e.preventDefault();
    const { data, error } = await supabase
      .from("mensajes_chat")
      .insert({
        user_id: usuario.id,
        nombre_usuario: usuario.user_metadata.first_name,
        mensaje: mensaje,
        user_id_chat: receptor,
        visto: false,
      })
      .select();

    if (data) {
      console.log(data);
    }
    if (error) {
      console.log(error);
    }
    //regresar el tamaño original del textarea
    const textarea = mensajeAreaRef.current;
    if (textarea) {
      textarea.style.height = "40px";
    }
    setMensaje("");
    mensajeAreaRef.current.blur();
    ajustarAlturaTextarea();
    abajo();
  }

  return (
    <div className={estilo.chat}>
      {receptorDatos && (
        <div className={estilo.datos_receptor}>
          {receptorDatos.map((e) => (
            <div key={e.id} className={estilo.tarjeta_receptor}>
              <div className={estilo.perfil_receptor}>
                <div className={estilo.foto}>
                  <img
                    src={url + e.user_id}
                    alt={e.nombre_usuario}
                    width="10px"
                    height="10px"
                  />
                </div>
                <h3>@{e.nombre_usuario}</h3>
              </div>

              <div className={estilo.estado}>
                {e.estado ? (
                  <div className={estilo.conectado}></div>
                ) : (
                  <div className={estilo.no_conectado}></div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {mensajes && (
        <div className={estilo.mensajes} ref={scrollRef}>
          {mensajes.sort().map((e) => (
            <div
              key={e.id}
              className={
                e.nombre_usuario == usuario.user_metadata.first_name
                  ? `${estilo.mensaje} ${estilo.emisor}`
                  : `${estilo.mensaje} ${estilo.receptor}`
              }
            >
              <h3>@{e.nombre_usuario}</h3>
              <p>{e.mensaje}</p>

              <div className={estilo.informacion_mensaje}>
                {/* {e.visto ? (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={estilo.visto}
                  >
                    <path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"></path>
                  </svg>
                ) : (
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    className={estilo.no_visto}
                  >
                    <path d="m2.394 13.742 4.743 3.62 7.616-8.704-1.506-1.316-6.384 7.296-3.257-2.486zm19.359-5.084-1.506-1.316-6.369 7.279-.753-.602-1.25 1.562 2.247 1.798z"></path>
                  </svg>
                )} */}

                <span>{tiempoTranscurrido(e.created_at)}</span>
              </div>
              {/* <button>Eliminar</button> */}
            </div>
          ))}
        </div>
      )}

      <form onSubmit={enviarMensaje}>
        <textarea
          ref={mensajeAreaRef}
          type="text"
          placeholder="Mensaje..."
          value={mensaje}
          onChange={capturarTexto}
          rows="2"
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              enviarMensaje(event);
              ajustarAlturaTextarea();
            }
          }}
        />
        <button type="submit">
          <svg width="24" height="24" viewBox="0 0 24 24">
            <path d="m21.426 11.095-17-8A1 1 0 0 0 3.03 4.242l1.212 4.849L12 12l-7.758 2.909-1.212 4.849a.998.998 0 0 0 1.396 1.147l17-8a1 1 0 0 0 0-1.81z"></path>
          </svg>
        </button>
      </form>
    </div>
  );
}

export default Chat;
